import { useState } from "react";
import {motion} from 'framer-motion'
export default function ExpandableText({ text, limit = 100 }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => setIsExpanded((prev) => !prev);

  const displayText = isExpanded ? text : text.slice(0, limit) + (text.length > limit ? "..." : "");

  return (
    <motion.div className="flex flex-col gap-2 w-full">
      <p className="lg:text-[16px] text-[14px] leading-[20px] text-justify">
        {displayText}
      </p>

      {text.length > limit && (
        <button
          onClick={toggleExpand}
          className="text-blue-600 text-sm font-medium hover:underline self-start"
        >
          {isExpanded ? "نمایش کمتر" : "نمایش بیشتر"}
        </button>
      )}
    </motion.div>
  );
}
